export const localSponsor = {
	x: 4200, // Billboard coordinates
	y: 2000, // Billboard coordinates
	logoX: 4214,
	logoY: 2025,
	logoWidth: 345,
	logoHeight: 129
};

export const secondarySponsor = {
	...localSponsor,
	x: 3070,
	y: 2840,
	logoX: 3083,
	logoY: 2863
};

export const buildings = {
	sponsorLogo: {
		width: 140,
		height: 52
	},
	activities: {
		x: 2490,
		y: 2151,
		logoSponsorX: 2990,
		logoSponsorY: 2360
	},
	'cable-internet': {
		x: 4944,
		y: 2015,
		logoSponsorX: 5170,
		logoSponsorY: 2190
	},
	charity: {
		x: 3804,
		y: 1865,
		logoSponsorX: 3916,
		logoSponsorY: 1870
	},
	'child-care': {
		x: 2882,
		y: 2528,
		logoSponsorX: 2900,
		logoSponsorY: 2750
	},
	clothing: {
		x: 5278,
		y: 1856,
		logoSponsorX: 5540,
		logoSponsorY: 1820
	},
	'continue-education': {
		x: 3265,
		y: 1805,
		logoSponsorX: 3168,
		logoSponsorY: 1947
	},
	'dining-out': {
		x: 4579,
		y: 2724,
		logoSponsorX: 4745,
		logoSponsorY: 2960
	},
	electricity: {
		x: 3880,
		y: 2820,
		logoSponsorX: 3960,
		logoSponsorY: 3125
	},
	furniture: {
		x: 4084,
		y: 2752,
		logoSponsorX: 4303,
		logoSponsorY: 2900
	},
	gas: {
		x: 5170,
		y: 2880,
		logoSponsorX: 5260,
		logoSponsorY: 3180
	},
	grocery: {
		x: 3267,
		y: 2525,
		logoSponsorX: 3484,
		logoSponsorY: 2780
	},
	'home-improvements': {
		x: 3420,
		y: 1462,
		logoSponsorX: 3694,
		logoSponsorY: 1640
	},
	housing: {
		x: 4890,
		y: 2556,
		logoSponsorX: 5017,
		logoSponsorY: 2685
	},
	insurance: {
		x: 3993,
		y: 2242,
		logoSponsorX: 4174,
		logoSponsorY: 2250
	},
	investments: {
		x: 4898,
		y: 2194,
		logoSponsorX: 5030,
		logoSponsorY: 2300
	},
	'pet-care': {
		x: 4650,
		y: 1900,
		logoSponsorX: 4830,
		logoSponsorY: 1960
	},
	placeholder1: {
		x: 5740,
		y: 1770,
		logoSponsorX: 5960,
		logoSponsorY: 2030
	},
	placeholder2: {
		x: 4075,
		y: 1640,
		logoSponsorX: 4330,
		logoSponsorY: 1900
	},
	placeholder3: {
		x: 4430,
		y: 2845,
		logoSponsorX: 4590,
		logoSponsorY: 3120
	},
	'school-expenses': {
		x: 3045,
		y: 2165,
		logoSponsorX: 3280,
		logoSponsorY: 2334
	},
	'self-care': {
		x: 5209,
		y: 2703,
		logoSponsorX: 5549,
		logoSponsorY: 2675
	},
	transportation: {
		x: 5453,
		y: 2206,
		logoSponsorX: 6157,
		logoSponsorY: 2243
	},
	vacation: {
		x: 5943,
		y: 1591,
		logoSponsorX: 5820,
		logoSponsorY: 1580
	},
	'water-trash': {
		x: 2890,
		y: 1530,
		logoSponsorX: 3120,
		logoSponsorY: 1900
	}
};
